import type { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';

import { DEFAULT_LOCALE } from '../configuration/lang/lang';
import { useAppSelector } from '../configuration/setup/hooks';
import { getDisplayMessages, getLocale } from '../configuration/lang/langSlice';
import { PortalContextProvider, PortalHost, usePortalHost } from '../hooks/usePortal';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';

const AppLayout = ({ children }: PropsWithChildren) => {
    const [portalHost, setPortalHost] = usePortalHost();

    const footer = (
        <PortalHost
            element={
                <div className='display-flex justify-content-between flex-row-reverse padding-20 bg-white border border-top-only rounded-bottom hidden-empty non-printable' />
            }
            onHost={setPortalHost}
        />
    );

    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!(displayMessages && userLocale)) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <ApplicationLayout data-testid={'app-layout'} className='printable-content'>
                <div className='display-flex flex-column height-100vh'>
                    <div className={'flex-1-1 padding-20 overflow-y-auto'}>
                        <PortalContextProvider host={portalHost}>{children}</PortalContextProvider>
                    </div>
                    {footer}
                </div>
            </ApplicationLayout>
        </IntlProvider>
    );
};

export default AppLayout;
